// extracted by mini-css-extract-plugin
module.exports = {"root":"FilterClinic_root__K8xM2"};